import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import ReduxFormInput from '../../../common/forms/ReduxFormInput';

class SwingSubmittalPurchaseForm extends Component {
  static propTypes = {
    ...formPropTypes,
    onCancel: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      price: props.types.data[0].price,
    };
  }

  onChange = event => {
    this.setState({
      price: this.props.types.data.find(type => type.id.toString() === event.currentTarget.value).price,
    });
  };

  render() {
    const { handleSubmit, onCancel, source, submitting, types } = this.props;
    const { price } = this.state;

    const typeOptions = types.data.map((type, i) => (
      <option key={i} value={type.id}>
        {`${type.long_name} (${numeral(type.price / 100).format('$0,0.00')})`}
      </option>
    ));

    return (
      <div className="purchase-form">
        <form onSubmit={handleSubmit}>
          <div className="ss__request-form">
            <h3>Confirm Swing Submittal Purchase</h3>
            <Field name="type" component={ReduxFormInput} onChange={this.onChange} label="Swing Type">
              <select>{typeOptions}</select>
            </Field>
            <p>
              By confirming your purchase, your <span className="card-type">{source.get('brand')}</span> ending in{' '}
              <strong>{source.get('last4')}</strong> will be charged <em>{numeral(price / 100).format('$0,0.00')}</em>{' '}
            </p>
          </div>
          <div className="modal__actions">
            <button type="button" className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
              Cancel
            </button>
            <button type="submit" className="button" disabled={submitting}>
              Confirm Purchase
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'swingSubmittalPurchaseForm',
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
})(SwingSubmittalPurchaseForm);



// WEBPACK FOOTER //
// ./src/subscription/coaching/swing-submittals/SwingSubmittalPurchaseForm.js